<template>
    <v-dialog v-model="value" scrollable persistent :width="width || '800px'" :fullscreen="full_screen || isMobile">
        <v-card rounded="lg">
            <v-card-title dense class="d-flex justify-space-between align-center py-2"> 
                <div>
                    <slot name="title" style="max-height: 88vh">
                        {{ title }}
                    </slot>
                    <slot name="title-badge"></slot>
                </div>

                <div class="d-flex align-center">
                    <v-icon v-if="reload" @click="$emit('reload')" class="float-left text-grey">mdi-refresh</v-icon>
                    <v-icon @click="$emit('close')" class="text-grey ml-2">mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-divider></v-divider>
            <v-progress-linear indeterminate v-if="loading" color="primary"></v-progress-linear>

            <div :class="'py-2 px-2 '+(color || '')" :style="`max-height: 95vh; overflow:auto;`">
                <slot></slot>
            </div>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="$emit('close')" outlined color="error">
                    close
                </v-btn>
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['title', 'value', 'loading', 'width', 'color', 'reload', 'full_screen'],
    computed: {
        isMobile() {
            const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            return regex.test(navigator.userAgent);
        }

    },
}
</script>